export const SET_LIMITED_NOTIFICATIONS = "SET_LIMITED_NOTIFICATIONS";
export const SET_NOTIFICATIONS = "SET_NOTIFICATIONS";
export const SET_NEW_NOTIFICATION = "SET_NEW_NOTIFICATION";
export const SET_MARK_AS_READ_NOTIFICATION = "SET_MARK_AS_READ_NOTIFICATION";
export const DELETE_NOTIFICATIONS = "DELETE_NOTIFICATIONS";
